<template>
	<div class="project-metrics" v-if="timeEnabled || invoicesEnabled">
		<div class="metric-card" v-if="invoicesEnabled">
			<span>{{ $t('projects.overview.total-invoiced') }}</span>
			<strong>{{ totalInvoiced }}</strong>
		</div>
		<div class="metric-card" v-if="invoicesEnabled">
			<span>{{ $t('projects.overview.total-payments') }}</span>
			<strong>{{ totalReceived }}</strong>
		</div>
		<div class="metric-card" v-if="timeEnabled">
			<span>{{ $t('projects.overview.estimated-hours') }}</span>
			<strong>{{ formatTimeEstimate }}</strong>
		</div>
		<div class="metric-card" v-if="timeEnabled">
			<span>{{ $t('projects.overview.hours-worked') }}</span>
			<strong>{{ formattedTimeWorked }}</strong>
		</div>
	</div>
</template>

<script>
	import ProjectService from "@/modules/projects/ProjectService";

	export default {
		name: 'TimeAndMoney',

		props: ['project'],

		components: {},

		data: function () {
			return {
				projectService: new ProjectService(),
				payments: [],
				timeWorked: 0,
			};
		},

		mounted() {
			this.getInvoicesForProject();
			this.getTimeWorkedForProject()
		},

		beforeDestroy() {},

		methods: {
			getInvoicesForProject: function(){
				this.projectService.getProjectPayments(this.project.id).then((res) => {
					this.payments.splice(0,this.payments.length);
					this.payments.push(... res.data);
				})
			},

			getTimeWorkedForProject: function() {
				this.projectService.getTimeWorkedForProject(this.project.id).then((res) => {
					this.timeWorked = res.data;
				})
			}
		},

		computed: {
      timeEnabled: function(){
        return this.$store.getters.getFeatures.timeEnabled && this.project.showTimeWorkedInPortal;
      },

      invoicesEnabled: function(){
        return this.$store.getters.getFeatures.invoicesEnabled && this.$store.getters.getFeatures.summaryFinancialsEnabled;
      },

			totalInvoiced: function(){
				return this.$formatters.dollars(this.payments.reduce((sum, { amount }) => sum + amount, 0));
			},

			totalReceived: function(){
				return this.$formatters.dollars(this.payments.filter((p) => p.invoiceStatus === 'PAID').reduce((sum, { amount }) => sum + amount, 0));
			},

			formatTimeEstimate: function(){
				if(this.project.feeSchedule){
					let min =  this.project.feeSchedule.estimateMin;
					let max = this.project.feeSchedule.estimateMax;

					if(min && max){
						return min + '-' + max;
					}else if(min){
						return min;
					}else if(max){
						return max;
					}else {
						return '--'
					}
				}else{
					return '--'
				}

			},

			formattedTimeWorked: function(){
        if(this.timeWorked) {
          return this.$formatters.formatSeconds(this.timeWorked);
        }else{
          return '--'
        }
			}
		},
	};
</script>

<style scoped lang="scss">
	.project-metrics {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 10px;
		margin-top: 22px;
	}

	.metric-card {
		min-width: 0;
		display: grid;
		gap: 7px;
		padding: 14px;
		border: 1px solid var(--portal-border);
		border-radius: var(--brand-surface-radius, 14px);
		background: var(--portal-canvas);
	}

	.metric-card span {
		overflow: hidden;
		color: var(--portal-muted);
		font-size: 12px;
		font-weight: 600;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.metric-card strong {
		color: var(--portal-text);
		font-size: clamp(17px, 2vw, 22px);
		font-weight: 680;
		letter-spacing: -0.02em;
	}

	@media (max-width: 1100px) {
		.project-metrics {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}

	@media (max-width: 599px) {
		.project-metrics {
			grid-template-columns: minmax(0, 1fr);
		}
	}
</style>
